import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/tina.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Button from "react-bootstrap/Button";
import Card  from "react-bootstrap/Card";


function Home() {

  return (
    <section style={{marginTop:"-100px"}}>
      <Container fluid className="home-section" id="home">
        <Particle />
        
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> TINASHE MANGONDO </strong>
              </h1>
              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
              <div style={{ padding: 50, textAlign: "left",marginTop:"-50px" }}>
              {/* <h4 style={{padding: 50,fontStyle:"italic",fontFamily:"rockwellregular",fontSize:20}}>I've always been interested in computing and technology. I make an effort to keep up with the most recent technical developments because of this. */}
              
              {/* Kindly review my blog if you would want to contribute and work with me on your initiatives.</h4> */}
              <Card className="project-card-view">
                <Card.Header>Quote</Card.Header>
                <Card.Body>
                  <blockquote className="blockquote mb-0">
                    <p style={{textAlign: "left"}}>
                      {' '}
                      Despite how widespread information technology has grown in people's lives, many of us take it for granted. It has evolved into a force for good in many situations as a result of its widespread use, but there has also always been a chance that it may be used for evil.
                      {' '}
                    </p>
                    <footer className="blockquote-footer">
                      Tinashe Mangondo <cite title="Source Title">in TechGeek</cite>
                    </footer>
                  </blockquote>
                </Card.Body>
              </Card>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 10 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "700px",height:"100%", width:"900px"}}
              />
            </Col>
            <col>
            
            </col>
          </Row>
          {/* <Home2 /> */}
        </Container>
        {/* <Home2 /> */}
       

      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
